<template>
  <div :class="{bubble: true, 'phase-next': phase_next }" class="evaluation">
    <template v-if="!phase_next">
      <span>On est {{ formatDate(new Date().toISOString().slice(0, 19).replace('T', ' ')) }}, comment te sens-tu aujourd-hui ?</span>
      <ul class="mascotte-day">
        <li><img @click="evaluation_0" :src="require('@/assets/images/mascotte/m-0.png')" alt="Pas très bien" title="Pas très bien"/><span>Pas très bien</span></li>
        <li><img @click="evaluation_1" :src="require('@/assets/images/mascotte/m-1.png')" alt="Moyen" title="Moyen"/><span>Moyen</span></li>
        <li><img @click="evaluation_2" :src="require('@/assets/images/mascotte/m-2.png')" alt="Bien" title="Bien"/><span>Bien</span></li>
        <li><img @click="evaluation_3" :src="require('@/assets/images/mascotte/m-3.png')" alt="Super bien" title="Super bien"/><span>Super bien</span></li>
      </ul>
    </template>
    <template v-else>
      Mince, tu veux me dire ce qui ne va pas ?
      <ul class="">
        <li @click="evaluation_00"><span>J’ai mal quelque part</span></li>
        <li @click="evaluation_01"><span>J’ai peur</span></li>
        <li @click="evaluation_02"><span>Je me pose des questions et je voudrais des réponses </span></li>
        <li @click="evaluation_03"><span>Je m’ennuie ou je suis triste</span></li>
      </ul>
    </template>
  </div>       
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { formatDate } from '@/functions'

  // TODO remplacer les this.message par notre nouveau systeme de messagerie
  export default {
    data () {
      return {
        phase_next: false,
        formatDate
      }
    },
    methods: {
      ...mapActions(['clearMessage', 'newAutoEvaluation', 'addNotice']),
      clear () {
        this.clearMessage({ messageType: this.currentMessage.type })
      },
      async evaluation_0() {
        try{
          this.phase_next = true
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_00() {
        try{
          await this.newAutoEvaluation({value: 0, comment: "J’ai mal quelque part"});
          this.addNotice({message: `Si tu as mal il faut le dire à tes parents ou directement à une infirmière. C’est elle qui peut essayer de soulager ta douleur. N’hésite pas à en parler. Courage.`})
          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_01() {
        try{
          await this.newAutoEvaluation({value: 0, comment: "J’ai peur"});
          this.addNotice({message: `C’est normal d’avoir peur parfois car ce n’est pas très drôle ce qui t’arrive. Tu peux en parler à tes parents, à la psychologue du service si tu es à l’hôpital ou à n’importe quel membre de ta Globulo Team de soignants. Ne reste pas seul.e à avoir peur en tout cas.`})
          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_02() {
        try{
          await this.newAutoEvaluation({value: 0, comment: "Je me pose des questions et je voudrais des réponses"});
          this.addNotice({message: `C’est bien normal de vouloir mieux comprendre ce qui se passe : comment on va te soigner, comment tu vas passer tes journées à l’hôpital etc… Si tu as des pages mini-jeux débloquées, tu peux cliquer sur des liens pour lire une BD, voir une vidéo ou lire une fiche avec des dessins. Sinon ta Globulo team de soignants et tes parents peuvent sûrement te répondre, poses-leur ta question.`})

          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_03() {
        try{
          await this.newAutoEvaluation({value: 0, comment: "Je m’ennuie ou je suis triste"});
          this.phase_next = false
          this.addNotice({message: `Je suis là pour ne pas que tu t’ennuies justement. En attendant de pouvoir jouer au jeu Fil Rouge, pourquoi ne pas envoyer un petit message à ta communauté pour que tes amis te tiennent compagnie ? Et si tu changeais la tête de ton avatar ? Tes parents et ton équipe soignante sont là pour te réconforter. Appelle-les.`})

          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_1() {
        try{
          await this.newAutoEvaluation({value: 1});
          this.addNotice({message: `Si tu n’es pas très en forme ou n’as pas le moral aujourd’hui, n’hésite pas à le dire à tes parents, ta communauté ou ta Globulo Team de soignants. Courage à toi.`})

          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_2() {
        try{
          await this.newAutoEvaluation({value: 2});
          this.addNotice({message: `Tant mieux je suis content que tu ailles bien, tu pourras redonner ton humeur demain.`})

          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
      async evaluation_3() {
        try{
          await this.newAutoEvaluation({value: 3});
          this.addNotice({message: `Super si tout va bien, passe une excellente journée ! Tu pourras redonner ton humeur demain.`})

          await this.clear()
        } catch(ex) {
          console.log(ex)
        }
      },
    },
    computed: {
      ...mapGetters(['currentMessage'])
    }
  }
</script>

<style scoped>

  .mascotte.consol {
    display: block;
    width: 100px;
    height: 80px;
    background: #fff;
    top: 230px;
    right: 0;
    border-radius: 50px 0 0 50px;
    position: fixed;
    z-index: 100;
  }
  .mascotte.consol.masque.off {
    right: -400px;
  }
  .mascotte.consol.masque {
    right: 0;
  }
  .mascotte.consol .bubble {
    left: -290px;
    width: 300px;
    font-size: 21px;
    line-height: 25px;
    bottom: 25px;
  }
  .mascotte.consol img {
    max-width: 80px;
    margin-left: 10px;
    margin-top: -20px;
  }

  .mascotte.consol.byebye {
    animation-name: messageoff;
    animation-duration: 0.8s;
    animation-delay: 0.2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
  
  @keyframes messageoff {
    0% {
      right: -200px; 
    }
    100% {
      right: 0;
    }
  }
  .dashboard .hal .box-mascotte .bubble.evaluation.right {top: -80px;}
  .side-message .mascotte-day li { height: 105px; }
	.side-message .mascotte-day li span {  font-size: 18px; }
	.side-message .mascotte-day img {     max-width: 60px; }

</style>
